import * as stylex from '@stylexjs/stylex'
import { Box } from '../Box/Box'
import { NoImage } from '../Icons'
import { colors } from '../tokens/colors.stylex'

interface NoImageSizeProps {
  width?: string | number
  height?: string | number
}

const noImageStyles = stylex.create({
  root: (backgroundColor?: string) => ({
    overflow: 'hidden',
    alignItems: 'center',
    backgroundColor,
    display: 'flex',
    justifyContent: 'center',
  }),
  border: {
    borderColor: colors.grey300,
    borderRadius: '2px',
    borderStyle: 'solid',
    borderWidth: 1,
  },
  size: (props: NoImageSizeProps) => ({
    height: props?.height ?? 'auto',
    maxHeight: '100%',
    maxWidth: '100%',
    minHeight: props?.height ? 'auto' : '80px',
    minWidth: props?.width ? 'auto' : '80px',
    width: props?.width ?? 'auto',
  }),
  icon: (size: number | string | undefined) => ({
    height: size ?? '60%',
    width: size ?? '60%',
  }),
  aspectRatio: (aspectRatio: string) => ({
    aspectRatio,
  }),
})

export interface PlaceholderNoImageProps {
  width?: string | number
  height?: string | number
  iconSize?: string | number
  noBorder?: boolean
  aspectRatio?: string
  backgroundColor?: string
}

export const PlaceholderNoImage = ({ width, height, iconSize, noBorder, aspectRatio, backgroundColor = colors.white }: PlaceholderNoImageProps) => {
  return (
    <Box rootStyle={[noImageStyles.root(backgroundColor), noImageStyles.size({ width, height }), !noBorder && noImageStyles.border, !!aspectRatio && noImageStyles.aspectRatio(aspectRatio)]}>
      <NoImage {...stylex.props(noImageStyles.icon(iconSize))} />
    </Box>
  )
}
